import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller';

export const useHasForgeAccess = (): boolean => {
	const isAnonymous = useIsAnonymous();
	return !isAnonymous;
};
